enum ESubmit {
  uploadSubmit = 'submit/upload',
}

export default ESubmit;
